export const AMOUNT_RANGE_KEYS = [
  'min_amount',
  'max_amount',
  'no_min_max_amount',
] as const

const nzdFormatter = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
  maximumFractionDigits: 0,
})

export function formatNZD(n: unknown): string {
  const num = Number(n)
  if (!Number.isFinite(num)) return String(n)
  return nzdFormatter.format(num)
}

export interface AmountRangeInput {
  min?: unknown
  max?: unknown
  no_min_max_amount?: unknown
}

export function formatAmountRange({
  min,
  max,
  no_min_max_amount,
}: AmountRangeInput): string {
  if (no_min_max_amount === true) return 'Variable (no min/max)'

  const hasMin = min !== null && min !== undefined && min !== ''
  const hasMax = max !== null && max !== undefined && max !== ''

  if (hasMin && hasMax) return `${formatNZD(min)} – ${formatNZD(max)}`
  if (hasMin) return `from ${formatNZD(min)}`
  if (hasMax) return `up to ${formatNZD(max)}`
  return 'unspecified'
}

export function extractAmountRange(payload: Record<string, unknown>): AmountRangeInput {
  return {
    min: payload['min_amount'],
    max: payload['max_amount'],
    no_min_max_amount: payload['no_min_max_amount'],
  }
}
